import React from 'react';
import { Routes as RouterRoutes, Route } from 'react-router-dom';
import Dashboard from './components/Dashboard';
import Bibliotheque from './components/Bibliotheque';
import UploadIndexation from './components/UploadIndexation';
import UnifiedReader from './components/UnifiedReader';
import IA from './components/IA_Persistent';
// Graphes.tsx fabriquait ses concepts et thèmes côté client à partir des titres
// de livres (aucun appel réseau). GrapheConceptuel consomme les vraies routes
// /api/graphs. Le fichier Graphes.tsx est conservé mais n'est plus routé.
import GrapheConceptuel from './components/GrapheConceptuel';
import Recherche from './components/Recherche';
import DataManagement from './components/DataManagement';
import Settings from './components/Settings';
import SystemHealth from './components/SystemHealth';
import Projects from './components/Projects';
import ProjectView from './components/ProjectView';
import NotFound from './components/NotFound';
import CataloguePage from './components/CataloguePage';
import SynapseOpen from './pages/SynapseOpen';
import SynapseProject from './pages/SynapseProject';
import ReinitialisationMotDePasse from './pages/ReinitialisationMotDePasse';

/**
 * Definition centralisee des routes (extrait de App.jsx pour maintenabilite).
 *
 * Périmètre : seuls les écrans dont chaque contrôle visible aboutit réellement
 * sont routés. Six écrans ont été retirés de la navigation faute de pouvoir
 * tenir ce qu'ils affichent — leur code reste dans le dépôt, la réintégration
 * ne demande que de rétablir l'import et la ligne <Route> :
 *
 *   /calibre-web      CalibreWebEmbed      dépend d'un serveur Calibre-Web externe
 *   /compare          MultiDocCompare      plante sur un champ nul, réponses non vérifiées
 *   /canvas           SpatialWorkspace     persistance localStorage seule, citation factice
 *   /cover-extraction CoverExtractionPanel un AbortController partagé annule ses propres appels
 *   /curation         CurationPanel        à revoir : le serveur indexe désormais les sources acceptées
 *   /notion           NotionArchivePage    aucun endpoint backend correspondant
 *
 * Dialogue simulé, outils Perplexity et synthèse ont été démontés au lot 2
 * (code supprimé, serveur compris).
 */
export function AppRoutes() {
  return (
    <RouterRoutes>
      <Route path="/dashboard" element={<Dashboard />} />
      <Route path="/" element={<Bibliotheque />} />
      <Route path="/catalogue" element={<CataloguePage />} />
      <Route path="/upload" element={<UploadIndexation />} />
      <Route path="/lecteur/:bookId" element={<UnifiedReader />} />
      <Route path="/lecteur" element={<UnifiedReader />} />
      <Route path="/ia" element={<IA />} />
      <Route path="/graphes" element={<GrapheConceptuel />} />
      <Route path="/recherche" element={<Recherche />} />
      <Route path="/gestion" element={<DataManagement />} />
      <Route path="/parametres" element={<Settings />} />
      <Route path="/systeme" element={<SystemHealth />} />
      <Route path="/admin" element={<SystemHealth />} />
      <Route path="/projects" element={<Projects />} />
      <Route path="/projects/:projectId" element={<ProjectView />} />
      <Route path="/synapse/open" element={<SynapseOpen />} />
      <Route path="/synapse/projects/:projectId" element={<SynapseProject />} />
      {/* Normalement rendue par LoginPage (aucune session) ; cette entrée
          couvre le lien ouvert dans un navigateur où une session existe. */}
      <Route path="/reinitialisation" element={<ReinitialisationMotDePasse />} />
      <Route path="*" element={<NotFound />} />
    </RouterRoutes>
  );
}
